import React from 'react';
import styled from '@emotion/styled';
import { useTheme } from 'emotion-theming';
import { useSelector } from 'react-redux';
import IcomoonReact from 'icomoon-react';

import iconSet from '../../../../shared/images/teambuildr-selection.json';
import { ColorWhite, BoxShadow } from '../../../../shared/GlobalStyles';

const StatusIndicatorContainer = styled('div')`
  position: fixed;
  bottom: 20px;
  left: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
  width: auto;
  border-radius: 500px;
  padding: 8px;
  background-color: ${ColorWhite};
  box-shadow: ${BoxShadow};
`;

const IndicatorCircle = styled('div')`
  border-radius: 50%;
  height: 15px;
  width: 15px;
  background-color: ${(props) => (props.isConnected ? props.theme.colors.green : props.theme.colors.red)};
`;

const StatusIndicator = () => {
  const isConnected = useSelector((state) => state.socketTester.feedUi.isConnected);
  const theme = useTheme();

  return (
    <StatusIndicatorContainer aria-label={`Connection status: ${isConnected ? 'Connected' : 'Disconnected'}`}>
      <IcomoonReact
        iconSet={iconSet}
        size={15}
        icon='swap'
        color={theme.colors.lightText[0]}
      />
      <IndicatorCircle isConnected={isConnected} theme={theme} />
    </StatusIndicatorContainer>
  );
};

export default StatusIndicator;
